import React, { useRef, useEffect } from "react";
import "./Residences.css";
import Swiper from "swiper";
import "swiper/swiper-bundle.css";
import data from "./slider.json";
import { Container } from "react-bootstrap";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";
import Heading from "../Heading";
import Companies from "../Companies/Companies";

const Residences = () => {
  const swiperRef = useRef(null);

  useEffect(() => {
    let swiper = null;
    const updateSwiper = () => {
      const screenWidth = window.innerWidth;
      const slidesPerView =
        screenWidth < 768
          ? 1
          : screenWidth < 991
          ? 2
          : screenWidth < 1399
          ? 3
          : 4; // set slidesPerView based on screen width
      if (swiper) {
        swiper.destroy(true, true); // destroy the old Swiper instance
      }
      swiper = new Swiper(swiperRef.current, {
        spaceBetween: 50,
        slidesPerView: slidesPerView,
        loop: true,
        centeredSlides: true,
        autoplay: {
          delay: 2000,
          disableOnInteraction: false,
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
      });
    };
    updateSwiper(); // initialize Swiper on component mount
    window.addEventListener("resize", updateSwiper); // update Swiper when the window is resized
    return () => {
      window.removeEventListener("resize", updateSwiper); // remove event listener on unmount
      swiper.destroy(true, true); // destroy the Swiper instance
    };
  }, []);
  const previous = () => {
    swiperRef.current.swiper.slidePrev();
  };
  const next = () => {
    swiperRef.current.swiper.slideNext();
  };

  const mapingData = data.map((e, i) => {
    return (
      <div className="swiper-slide  slide-preview pb-4" key={i}>
        <div className="card ">
          <img
            src={require(`../../imgs/${e.image}.png`)}
            className="img-fluid"
            alt=""
          />
          <div className="card-body">
            <h5 className="card-title text-black-50">
              <span className="text-warning">+ </span>
              {e.price}
            </h5>
            <h3>{e.name}</h3>
            <p className="card-text text-black-50">{e.detail}</p>
          </div>
        </div>
      </div>
    );
  });
  const headingTagData = {
    h2: "Best Choices",
    h3: "Popular Residencies",
  };
  return (
    <section className="slider">
      <Container>
        <div className="heading d-flex align-items-center justify-content-between p-3">
          <Heading h2={headingTagData.h2} h3={headingTagData.h3} />
          <div className="d-flex align-items-center justify-content-center gap-2">
            <span className="direction" onClick={previous}>
              <FaArrowLeft />
            </span>
            <span className="direction" onClick={next}>
              <FaArrowRight />
            </span>
          </div>
        </div>
        <div ref={swiperRef} className="swiper-container">
          <div className="swiper-wrapper">{mapingData}</div>
        </div>
      </Container>
      <Companies />
    </section>
  );
};

export default Residences;
